if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // ✅ Sync slide change
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce((event) => {
            const mediaId = event.detail.currentElement.dataset.mediaId;
            this.setActiveMedia(mediaId, false);
          }, 100)
        );


        // ✅ Thumbnail click
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
          thumb.querySelector('button').addEventListener('click', () => {
            this.setActiveMedia(thumb.dataset.target, false);
          });
        });


        // ✅ Thumbnail scroll arrows
        const prevBtn = this.elements.thumbnails.querySelector('.thumbnail-slider .slider-button--prev');
        const nextBtn = this.elements.thumbnails.querySelector('.thumbnail-slider .slider-button--next');
        const wrapper = this.elements.thumbnails.querySelector('.thumbnail-list');

        if (prevBtn && nextBtn && wrapper) {
          const enableArrows = () => {
            prevBtn.removeAttribute('disabled');
            nextBtn.removeAttribute('disabled');
          };

          prevBtn.addEventListener('click', () => {
            wrapper.scrollBy({ top: -100, behavior: 'smooth' });
            enableArrows();
          });
          nextBtn.addEventListener('click', () => {
            wrapper.scrollBy({ top: 100, behavior: 'smooth' });
            enableArrows();
          });

          enableArrows();
          new MutationObserver(enableArrows).observe(prevBtn, { attributes: true });
          new MutationObserver(enableArrows).observe(nextBtn, { attributes: true });
        }

        // ✅ Main gallery arrows
        this.prevArrow = this.querySelector('.gallery-button--prev');
        this.nextArrow = this.querySelector('.gallery-button--next');
        if (this.prevArrow && this.nextArrow) {
          this.prevArrow.addEventListener('click', () => this.navigateGallery(-1));
          this.nextArrow.addEventListener('click', () => this.navigateGallery(1));
        }

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches)
          this.removeListSemantic();
      }

      // 🔹 Arrow navigation for main gallery
      navigateGallery(direction) {
        const items = [
          ...this.elements.viewer.querySelectorAll('[data-media-id]')
        ];

        const activeIndex = items.findIndex((el) =>
          el.classList.contains('is-active')
        );

        let newIndex = activeIndex + direction;
        if (newIndex < 0) newIndex = items.length - 1;
        if (newIndex >= items.length) newIndex = 0;

        this.setActiveMedia(items[newIndex].dataset.mediaId, false);
      }


      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;

        const mediaItems = [
          ...this.elements.viewer.querySelectorAll('[data-media-id]')
        ];
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        mediaItems.forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (this.elements.viewer.slider) {
          this.elements.viewer.slider.slideTo(mediaItems.indexOf(activeMedia));
        }

        const thumb = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(thumb);
      }


      setActiveThumbnail(thumbnail) {
        if (!thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((btn) => btn.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', 'true');
      }


      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}
